"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RepeatedBioTypeError = exports.EBTSParseError = exports.NoWSQImageForModality = exports.InvalidImageFormatError = exports.UnsupportedImageFormatError = exports.FingerPositionNotFoundError = exports.ImageHasNoMetadata = exports.AssertionError = exports.UnsupportedBioTypeError = exports.MismatchedImagesError = exports.MissingMandatoryFieldError = exports.BadIndexError = void 0;
const types_1 = require("./types");
/**
 * Throw BadIndexError when the index data can't be separated to extract the type
 */
class BadIndexError extends Error {
    constructor(message = 'Bad or malformed index') {
        super(message);
        this.name = types_1.LEBADINDEX_ERROR_NAME;
        Object.setPrototypeOf(this, BadIndexError.prototype);
    }
}
exports.BadIndexError = BadIndexError;
/**
 * Throw MissingMandatoryFieldError when a mandatory field was not found in the JFD
 */
class MissingMandatoryFieldError extends Error {
    constructor(field) {
        const message = `Missing value in mandatory field: ${field}`;
        super(message);
        this.name = types_1.LEMISSING_MANDATORY_FIELD_NAME;
        Object.setPrototypeOf(this, MissingMandatoryFieldError.prototype);
    }
}
exports.MissingMandatoryFieldError = MissingMandatoryFieldError;
/**
 * Throw MismatchedImagesError when there are problems with the lists passed to the zip function
 */
class MismatchedImagesError extends Error {
    constructor() {
        const message = 'JFD images and raw images lists should be the same length and contain the same image IDs only once';
        super(message);
        this.name = types_1.LEMISMATCHED_IMAGES_ERROR;
        Object.setPrototypeOf(this, MismatchedImagesError.prototype);
    }
}
exports.MismatchedImagesError = MismatchedImagesError;
/**
 * Throw UnsupportedBioTypeError when a Record Type for a given BioType was not found
 */
class UnsupportedBioTypeError extends Error {
    constructor(bioType) {
        super(`The given BioType ${bioType} does not correspond to any Record Type`);
        this.name = this.constructor.name;
    }
}
exports.UnsupportedBioTypeError = UnsupportedBioTypeError;
/**
 * Throw an AssertionError whenever something you expected to happen didn't happen 🤷
 */
class AssertionError extends Error {
    constructor(message) {
        super(`AssertionError: ${message}`);
        this.name = this.constructor.name;
    }
}
exports.AssertionError = AssertionError;
/**
 * Throw ImageHasNoMetadata when the image record doesn't have a metadata field
 */
class ImageHasNoMetadata extends Error {
    constructor() {
        const message = 'Image record should have a metadata field';
        super(message);
        this.name = types_1.LEIMAGE_HAS_NO_METADATA;
        Object.setPrototypeOf(this, ImageHasNoMetadata.prototype);
    }
}
exports.ImageHasNoMetadata = ImageHasNoMetadata;
/**
 * Throw FingerPositionNotFoundError when the BioType does not correspond to any finger position
 */
class FingerPositionNotFoundError extends Error {
    constructor(bioType) {
        const message = `No matching finger position found for BioType [${bioType}]`;
        super(message);
        this.name = types_1.LEFINGER_POSITION_NOT_FOUND_ERROR;
        Object.setPrototypeOf(this, FingerPositionNotFoundError.prototype);
    }
}
exports.FingerPositionNotFoundError = FingerPositionNotFoundError;
/**
 * Throw UnsupportedImageFormatError when the passed buffer is not supported by the imaging library
 */
class UnsupportedImageFormatError extends Error {
    constructor(buffer, originalMessage) {
        const magic = [...buffer.slice(0, 4)].map((c) => `0x${c.toString(16)}`);
        const message = `Couldn't get metadata from the image, unsupported image format or corrupt file. Magic bytes: [${magic}]. ` +
            `Original Error: ${originalMessage}`;
        super(message);
        this.name = this.constructor.name;
    }
}
exports.UnsupportedImageFormatError = UnsupportedImageFormatError;
/**
 * Throw InvalidImageFormatError when the loaded image is supported but not a valid or expected format
 */
class InvalidImageFormatError extends Error {
    constructor(format) {
        const message = `The image is not of a valid format. Format: ${format}`;
        super(message);
        this.name = this.constructor.name;
    }
}
exports.InvalidImageFormatError = InvalidImageFormatError;
/**
 * Throw NoWSQImageForModality when there is no WSQ image for the modalities that need it
 */
class NoWSQImageForModality extends Error {
    constructor(uuid, modality) {
        super(`No WSQ image found for image UUID: ${uuid} with modality: ${modality}.`);
        this.name = this.constructor.name;
    }
}
exports.NoWSQImageForModality = NoWSQImageForModality;
/**
 * Throw this error whenever there is an error during parsing of the EBTS file
 */
class EBTSParseError extends Error {
    constructor(parserMessage, ebtsString, location, offset = 20) {
        // Get the context within the lines
        const context = ebtsString.slice(location.start.offset - offset, location.end.offset + offset);
        // Sanitize the lines
        const sanitized = context.replace(/\r/g, '\\r');
        // Construct the message
        let errMessage = `Error: ${parserMessage}.  Context: ${sanitized}`;
        // Same line vs errors spanning some lines
        if (location.start.line === location.end.line) {
            errMessage += ' (line ' + location.start.line + ')';
        }
        else {
            errMessage += ' (lines ' + location.start.line + ' to ' + location.end.line + ')';
        }
        // Set the message
        super(errMessage);
        this.name = this.constructor.name;
    }
}
exports.EBTSParseError = EBTSParseError;
/**
 * Throw this error whenever an image record has a BioType that has been previously seen within the same group
 */
class RepeatedBioTypeError extends Error {
    constructor(bioTypeMarker, imageBioType) {
        super(`Repeated BioType found: ${imageBioType} before the BioType marker: ${bioTypeMarker}`);
        this.name = this.constructor.name;
    }
}
exports.RepeatedBioTypeError = RepeatedBioTypeError;
//# sourceMappingURL=errors.js.map